<div class="item-content" data-e2e="ms-action-card">
  @if (useFallback()) {
    <div class="content">
      {{ item().fallbackText }}
    </div>
  }
  <div #cardContainer id="cardContainer"></div>
</div>
